export enum ExternalServiceCampaignEnum {
  Google = 'google',
  Bing = 'bing',
  Facebook = 'facebook',
}
